import ASCII from "./ASCII";
import { Encrypt, Decrypt ,Timestamp} from "@/utils/aes.js";
import { generateEncryptedParams } from "@/utils/AESs.js"
import service from '@/utils/service';
var MD5 = require('md5');

function getASCII(data) {
    return MD5(ASCII.sort_ascii(data)).toString().toUpperCase();
  }
  //ASCII加密
  function setASCII(data) {
    return ASCII.sort_ascii(data);
  }
  function times(data, fmt){
    var d = new Date(data);
    console.log(d,"---index-dddd")
    const m = (d.getMonth() + 1) < 10 ? ('0' + (d.getMonth()+1)):(d.getMonth()+1)
    const t = (d.getDate()) < 10 ? ('0' + d.getDate()):d.getDate()
    const h = (d.getHours()) < 10 ? ('0' + d.getHours()):d.getHours()
    const M = (d.getMinutes()) < 10 ? ('0' + d.getMinutes()):d.getMinutes()
    const s = (d.getSeconds()) < 10 ? ('0' + d.getSeconds()):d.getSeconds()
    // var m = d.getMonth()+1
    // console.log(m,"mmmmmmmmm")
    var datetime=d.getFullYear() + '-' + m + '-' + t ;
    var datetime2=d.getFullYear() + '-' + m + '-' + t + ' ' + h + ':' + M + ':' + s;
    if(fmt=='yyyy-mm-dd hh-MM-ss'){
      return datetime2
    }else {
      return datetime
    }
  }
  function chattimes(data){
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // 注意月份是从 0 开始计算的，所以要加 1
    const currentDay = currentDate.getDate();
    const d = new Date(data);
    const m = (d.getMonth() + 1) < 10 ? ('0' + (d.getMonth()+1)):(d.getMonth()+1)
    const t = (d.getDate()) < 10 ? ('0' + d.getDate()):d.getDate()
    const h = (d.getHours()) < 10 ? ('0' + d.getHours()):d.getHours()
    const M = (d.getMinutes()) < 10 ? ('0' + d.getMinutes()):d.getMinutes()
    // var m = d.getMonth()+1
    const datetime = d.getFullYear() + '-' + m + '-' + t ;
    const datetime2 = h + ':' + M
    if(currentYear==d.getFullYear()&&currentMonth==m&&currentDay==t) {
      
      return datetime2
    }else{
      return datetime
    }
  }
  function selectDictList(type){
  service.post("/admin-api/common/selectDictList",generateEncryptedParams({typeCode:type}))
  .then(res =>{
      if(res.data.code == 200){
          console.log(Decrypt(res.data.data),"234y3289u4y32ji")
          return  res.data.data
      } 
  })
}
function detectTheme() {
  const theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? 'dark' : 'light';
  return theme

}
  export{
      getASCII,
      setASCII,
      times,
      selectDictList,
      chattimes,
      detectTheme
  }
  